export default "__VITE_ASSET__1f7434b2__"